const activeUser = (userInfo) => {
  return {
    type: "ACTIVE_USER_INFO",
    payload: userInfo,
  };
};

export default activeUser;
